<ng-container *transloco="let t; prefix: 'tasks.taskDetail.products.editWarning'">
  <mat-dialog-content class="warning-content">
    <span class="warning-title headline-small">{{ t('title') }}</span>
    <span class="warning-description body-medium">{{ t('description') }}</span>
  </mat-dialog-content>

  <mat-dialog-actions class="warning-actions">
    <button matButton type="button" [mat-dialog-close]="false">
      {{ t('cancel') }}
    </button>
    <button matButton="filled" type="button" [mat-dialog-close]="true">
      {{ t('continue') }}
    </button>
  </mat-dialog-actions>
</ng-container>
